import { IPushesViewContext, PushesViewContext } from '../../pushesViewContext/pushesViewState/pushesViewContext';
import React, { useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import AdditionalModal from './AdditionalModal/AdditionalModal';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const {
		changeTypeOfModalWindow,
		setPushCallback,
		setRestaurantsForPush,
		pushCallback,
		typeOfModalWindow,
		restaurantsForPush,
	} = useContext<IPushesViewContext>(PushesViewContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const sendPush = async () => {
		if (pushCallback && typeOfModalWindow) {
			try {
				showLoader();
				await pushCallback(restaurantsForPush);
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				setPushCallback(null);
				hideLoader();
			}
		}
	};

	const closeModal = () => {
		changeTypeOfModalWindow(null);
		setRestaurantsForPush([]);
	};

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={sendPush}
				onFailureEvent={closeModal}
				isVisible={typeOfModalWindow === 'confirm'}
				description="pushInfo"
				typeOfInfoIcon="toConfirmPush"
			/>
			<ModalSentSuccessfully
				onConsentEvent={closeModal}
				isVisible={typeOfModalWindow === 'success'}
				description="pushSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={closeModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSendingPush"
			/>
			<AdditionalModal isVisible={typeOfModalWindow === 'showAdditionalModal'} />
		</div>
	);
};

export default ModalWindows;
